import React, { useState } from "react";
import styled from "styled-components";
import PageAutodisplayViewLinkEduDesktopLotation from "./PageAutodisplayViewLinkEduDesktopLotation";
import PageAutodisplayViewLinkEduMobileLotation from "./PageAutodisplayViewLinkEduMobileLotation";
import DeviceDetectionService from "../../../utils/DeviceDetectionService";
import { Button } from "../../../assets/styles/ButtonStyle";
import { H3, Body2 } from "../../../assets/styles/Typography";

const PageAutodisplayViewLinkEduLotation = () => {
  const [showDeviceSelection, setShowDeviceSelection] = useState(true);
  const [selectedDeviceType, setSelectedDeviceType] = useState(null);

  console.log("🎯 기기별 컴포넌트 라우터 - PageAutodisplayViewLinkEduLotation");

  // 디바이스 선택 핸들러
  const handleDeviceSelection = (deviceType) => {
    console.log(`🎯 사용자가 선택한 기기 타입: ${deviceType}`);

    let finalDeviceType = deviceType;

    // 자동 감지인 경우 실제 기기를 감지
    if (deviceType === "auto") {
      try {
        const detectedType = DeviceDetectionService.detectDevice();
        finalDeviceType = detectedType;
        console.log(`🔍 자동 감지 결과: ${detectedType}`);

        // 감지 결과 알림
        const deviceName =
          detectedType === "desktop"
            ? "데스크탑"
            : detectedType === "android"
            ? "안드로이드"
            : detectedType === "ios"
            ? "iOS"
            : "모바일";
        alert(`🔍 자동 감지 완료!\n감지된 기기: ${deviceName}`);
      } catch (error) {
        console.error("❌ 자동 감지 실패:", error);
        alert(
          "기기 자동 감지 중 오류가 발생했습니다. 데스크탑으로 설정합니다."
        );
        finalDeviceType = "desktop";
      }
    }

    // DeviceDetectionService를 사용해서 기기 타입 설정
    try {
      const updatedType =
        DeviceDetectionService.updateDeviceType(finalDeviceType);
      console.log(`✅ 기기 타입 업데이트 완료: ${updatedType}`);
    } catch (error) {
      console.error("❌ 기기 타입 설정 실패:", error);
      alert("기기 모드 설정 중 오류가 발생했습니다.");
      return;
    }

    const displayName =
      finalDeviceType === "desktop"
        ? "데스크탑"
        : finalDeviceType === "android"
        ? "안드로이드"
        : finalDeviceType === "ios"
        ? "iOS"
        : "모바일";

    console.log(`📱 기기 모드 설정 완료: ${displayName}`);

    // 디바이스 선택 완료, 콘텐츠 표시
    setSelectedDeviceType(finalDeviceType);
    setShowDeviceSelection(false);
  };

  // 디바이스 선택 화면 표시
  if (showDeviceSelection) {
    return (
      <DeviceSelectionContainer>
        <CenteredWrapper>
          <TitleArea>
            <H3 style={{ textAlign: "center", marginBottom: 20 }}>
              📱 디바이스 타입 선택
              <br />
              최적화된 사용 환경 설정
            </H3>
            <Body2
              color="gray600"
              style={{ textAlign: "center", marginBottom: 40 }}
            >
              사용하시는 디바이스에 맞는 최적화된 인터페이스를 제공합니다.
              <br />
              디바이스 타입을 선택해주세요.
            </Body2>
          </TitleArea>

          {/* 디바이스 선택 UI */}
          <DeviceSelectionRow>
            <DeviceCard>
              <DeviceIcon>🖥️</DeviceIcon>
              <DeviceTitle>OPS 모드</DeviceTitle>
              <DeviceDesc>OPS 환경에 최적화된 인터페이스입니다.</DeviceDesc>
              <Button
                Primary
                Large
                Fill
                style={{ width: "100%", marginTop: 18 }}
                onClick={() => handleDeviceSelection("desktop")}
              >
                OPS로 계속하기
              </Button>
            </DeviceCard>

            <DeviceCard>
              <DeviceIcon>📱</DeviceIcon>
              <DeviceTitle>Android 모드</DeviceTitle>
              <DeviceDesc>Android 환경에 최적화된 인터페이스입니다.</DeviceDesc>
              <Button
                Primary
                Large
                Fill
                style={{
                  width: "100%",
                  marginTop: 18,
                  backgroundColor: "#FF9800",
                }}
                onClick={() => handleDeviceSelection("android")}
              >
                Android로 계속하기
              </Button>
            </DeviceCard>
          </DeviceSelectionRow>
        </CenteredWrapper>
      </DeviceSelectionContainer>
    );
  }

  // 디바이스가 선택된 후 콘텐츠 표시
  if (selectedDeviceType === "desktop") {
    return <PageAutodisplayViewLinkEduDesktopLotation />;
  } else if (selectedDeviceType === "android") {
    return <PageAutodisplayViewLinkEduMobileLotation />;
  } else {
    // 기본값으로 데스크탑 컴포넌트 사용
    return <PageAutodisplayViewLinkEduDesktopLotation />;
  }
};

export default PageAutodisplayViewLinkEduLotation;

// 스타일 컴포넌트들
const DeviceSelectionContainer = styled.div`
  min-height: 100vh;
  background: #ffffff;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const TitleArea = styled.div`
  text-align: center;
  margin-bottom: 32px;
`;

const CenteredWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: calc(100vh - 100px);
  width: 100%;
  padding: 40px 20px;
`;

const DeviceSelectionRow = styled.div`
  display: flex;
  gap: 24px;
  justify-content: center;
  margin-top: 20px;
  flex-wrap: wrap;
  max-width: 1200px;
  margin-left: auto;
  margin-right: auto;
`;

const DeviceCard = styled.div`
  width: 320px;
  min-height: 320px;
  background: #fff;
  border-radius: 20px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.12);
  padding: 32px 24px 24px 24px;
  display: flex;
  flex-direction: column;
  align-items: center;
  border: 2px solid transparent;
  transition: all 0.3s ease;
  flex: 1;
  max-width: 320px;

  &:hover {
    transform: translateY(-4px);
    box-shadow: 0 12px 40px rgba(0, 0, 0, 0.15);
    border-color: #256ef4;
  }

  @media (max-width: 1024px) {
    width: 280px;
    max-width: 280px;
  }
`;

const DeviceIcon = styled.div`
  font-size: 60px;
  margin-bottom: 24px;
  filter: drop-shadow(0 4px 8px rgba(0, 0, 0, 0.1));
`;

const DeviceTitle = styled.div`
  font-size: 22px;
  font-weight: 700;
  color: #256ef4;
  margin-bottom: 16px;
  text-align: center;
`;

const DeviceDesc = styled(Body2)`
  color: #464c53;
  font-size: 16px;
  text-align: center;
  margin-bottom: 12px;
  flex-grow: 1;
  line-height: 1.6;
`;
